import { render, staticRenderFns } from "./Dashboard-mongustave-ad.vue?vue&type=template&id=641f1ccc&scoped=true&"
import script from "./Dashboard-mongustave-ad.vue?vue&type=script&lang=js&"
export * from "./Dashboard-mongustave-ad.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-mongustave-ad.vue?vue&type=style&index=0&id=641f1ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f1ccc",
  null
  
)

export default component.exports